// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"g9-z"};